module.exports = __webpack_public_path__ + "static/media/8_IMAGE_2-WAKAME-desktop.3dcc4fd8.jpg";